import React from "react";
import { useParams, Link, NavLink } from "react-router-dom";

function subnav({ list }) {
	return (
		<div className="sub-nav">
			<div className="sub-nav--inner">
				{(list ?? []).map((item, i) => (
					!item.hidden ? (
						<NavLink
							key={i}
							className={`sub-nav-links ${item.disabled ?? false ? "disabled" : "valid"}`}
							to={item.to}
						>
							{item.text}
						</NavLink>
					) : null
				))}
			</div>
		</div>
	);
}

export default subnav;
